import './pdfWorker';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './app.scss'
import './components/index.scss'
import { Provider } from 'react-redux';
import store from './stores/app-store';
import ToasterContainerComponent from './components/shared/toaster/toaster-container.component';
import React from 'react';

const App = React.lazy(() => import('./app'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    {<App />}
    <ToasterContainerComponent />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
